var map = {
	"./canon-logo.svg": 107,
	"./canon.svg": 108,
	"./chanel-logo.svg": 109,
	"./chanel.svg": 110,
	"./chatify.svg": 111,
	"./envita-logo.svg": 112,
	"./envita.svg": 113,
	"./favicon_round.svg": 114,
	"./forum.svg": 115,
	"./insta.svg": 116,
	"./jegs-logo.svg": 117,
	"./jegs.svg": 118,
	"./kaiser-logo.svg": 119,
	"./kaiser.svg": 120,
	"./portfolio.svg": 121,
	"./svg.ai": 122,
	"./toshiba-logo.svg": 123,
	"./toshiba.svg": 124,
	"./unipathic-logo.svg": 125,
	"./unipathic.svg": 126,
	"./vertisis-logo.svg": 127,
	"./vertisis-square.svg": 128,
	"./vertisis.svg": 129,
	"./wordpress.svg": 130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 106;